// |this script contains all the modular parts that allow
// |the user to use the web application
// |
// |This class contains the functionality object
import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Locale } from './locale.service';
import { ServerMapping } from './serverMapping.service';
import { Status } from './status.service';
import { CustomizingService } from './customizingService.service';
import { LabelFormatService } from './labelFormatService.service';
import { SupplierService } from './supplierService.service';
import { Observable } from 'rxjs/Observable';
import { GrowlManager } from './../manager/growl.manager';
import { InternalFunctionsRedirectService } from './internalFunctionsRedirectService.service';
import { LoginComponent } from './../components/login/login.component';


// |This class contains the functionalities
export class UserFunctions {
    // variable declaration
    public home                 = false;
    public rolelist             = false;
    public supplier             = false;
    public orders               = false;
    public deliveries           = false;
    public materials            = false;
    public stocks               = false;
    public inspections          = false;
    public documents            = false;

    // clear all the functionality triggers
    clear() {
        this.home           = false;
        this.rolelist       = false;
        this.supplier       = false;
        this.orders         = false;
        this.deliveries     = false;
        this.materials      = false;
        this.stocks         = false;
        this.inspections    = false;
        this.documents      = false;
    }
}

// |Thiss class contains the basic information about the login
export class LoginDetails {
    // variables declaration
    logged = false;
    loginName = '';
    password = '';
    firstName = '';
    lastName = '';
    userFunctions: UserFunctions = new UserFunctions();
}

// |This class describes a generic organization
export class PurchaseOrganization {
    // variables declaration
    code = '';
    description = '';
}

// |This class describes a generic company
export class Company {
    // variables declaration
    code = '';
    description = '';
}

// |This class contains the properties of an user
export class UserProperties {
    // variables declaration
    // sales_areas_list = undefined;
    user_code = '';
    user_name = '';
    country = '';
    country_name = '';
    role = '';
    purchase_organization = new PurchaseOrganization();
    company = new Company();
}

// |This class contains the costumer properties
export class SupplierProperties {
    // variables declaration
    supplier_code = '';
    supplier_name = '';
    agent_code = '';
    agent_name = '';
    agent_email = '';
}

// |This class contains the informations about what area is managed by the user
export class AreaManagerProperties {
    // variables declaration
    area_manager_code = '';
    area_manager_name = '';
}

// |This class contains the properties about an user agent
export class AgentProperties {
    // variables declaration
    agent_code = '';
    agent_name = '';
    agent_email = '';
}

// |This class contains the properties about a directional user
export class DirectionalProperties {
    // variables declaration
    dierctional_code = '';
    directional_name = '';
    directional_email = '';
}

// |This class contains all the previous exported classes as objects
@Injectable()
export class AccountService {
    // |Modular properties system declaration
    login: string[];
    loginDetails: LoginDetails;
    profiles = [];
    userProperties: UserProperties;
    supplierProperties: SupplierProperties;
    directionalProperties: DirectionalProperties;
    areaManagerProperties: AreaManagerProperties;
    agentProperties: AgentProperties;
    selectedProfile: Number;
    // selectedUserSalesArea: Number;
    // |Network object nodes
    loginComponent: LoginComponent;

    ui_context = '';

    // |Constructor function
    constructor(private http: Http,
                private httpClient: HttpClient,
                private locale: Locale,
                private serverMapping: ServerMapping,
                private status: Status,
                private ifrs: InternalFunctionsRedirectService,
                private customizingService: CustomizingService,
                private labelFormatService: LabelFormatService,
                private growlManager: GrowlManager,
                private supplierService: SupplierService) {

        this.locale.setAccountService(this);
        this.loginDetails = new LoginDetails();
        this.userProperties = new UserProperties();
        this.areaManagerProperties = new AreaManagerProperties();
        this.agentProperties = new AgentProperties();
        this.supplierProperties = new SupplierProperties();
        this.directionalProperties = new DirectionalProperties();
    }

    // |This function creates a bridge between this service and the login component
    setLoginComponentBridge(value: LoginComponent) {
        this.loginComponent = value;
    }

    // |This function clears ALL the user properties and information
    clear() {
        // clearing the data inside this object
        this.login = [];
        this.loginDetails.logged = false;
        this.loginDetails.firstName = undefined;
        this.loginDetails.lastName = undefined;
        this.loginDetails.userFunctions.clear();
        // calling all the clear functions
        this.clearProfiles();
        this.clearUserProperties();
        this.clearSupplierProperties();
        this.clearAgentProperties();
        this.clearAreaManagerProperties();
    }

    // |This function clears the profiles section...quite useless but ok
    clearProfiles() {
        this.profiles = [];
    }

    // |This function clears the user properties
    clearUserProperties() {
        this.userProperties.user_code = '';
        this.userProperties.user_name = '';
        this.userProperties.country = '';
        this.userProperties.country_name = '';
        this.userProperties.role = '';
        this.userProperties.purchase_organization = new PurchaseOrganization();
        this.userProperties.company = new Company();
    }

    // |This function clears the supplier properties
    clearSupplierProperties() {
        this.supplierProperties.supplier_code = '';
        this.supplierProperties.supplier_name = '';
        this.supplierProperties.agent_code = '';
        this.supplierProperties.agent_name = '';
        this.supplierProperties.agent_email = '';
    }

    // |This function clears the agent properties
    clearAgentProperties() {
        this.agentProperties.agent_code = '';
        this.agentProperties.agent_name = '';
        this.agentProperties.agent_email = '';
    }

    // |This function clears the area manager properties
    clearAreaManagerProperties() {
        this.areaManagerProperties.area_manager_code = '';
        this.areaManagerProperties.area_manager_name = '';

    }

    // |This function manages the login status of the users accounts
    setLogged(loginStatus: boolean) {
        this.loginDetails.logged = loginStatus;
        console.log('UserManager | user changed his login state to ' + loginStatus);
        if (this.loginDetails.logged === false) {
            this.doLogout();
        }
    }

    // |This function returns the current state of the user (is the user logged in or not?)
    isLogged() {
        return this.loginDetails;
    }

    // |=====|=====|=====|=====|=====|=====|=====|=====| USER FUNCTION UTILIY

    getUserFunctions() { return this.loginDetails.userFunctions; }

    buildUserFunctions(value) {
        let index = 0;
        let keepGoing = true;
        let studing = value[index];
        do {
            if (studing === undefined )    { keepGoing = false; } else {
                if (studing.function_name === 'VENMAT') { this.loginDetails.userFunctions.materials  = true; }
                if (studing.function_name === 'DMSFOR') { this.loginDetails.userFunctions.documents  = true; }
                if (studing.function_name === 'DOCPUR') { this.loginDetails.userFunctions.orders     = true; }
                if (studing.function_name === 'DELPUR') { this.loginDetails.userFunctions.deliveries = true; }
                if (studing.function_name === 'VSTOCK') { this.loginDetails.userFunctions.stocks     = true; }
                if (studing.function_name === 'DOCQMS') { this.loginDetails.userFunctions.inspections = true; }
            }
            index++;
            studing = value[index];
            this.loginDetails.userFunctions.home = true;
        } while (keepGoing === true);
        if (this.getUserRole() === 'STDSUP') {
            this.loginDetails.userFunctions.rolelist = false;
            this.status.setLandingPage('home');
        } else {
            this.loginDetails.userFunctions.rolelist = true;
            this.status.setLandingPage('rolelist');
            console.log('setted rolelist');
        }
        console.log('builded user functions');
        console.log(this.loginDetails.userFunctions);
        console.log('---');
    }

    // |Return the login name
    getLoginName() {
        return this.loginDetails.loginName;
    }

    // |Set login name
    setLoginName(loginName: string) {
        this.loginDetails.loginName = loginName;
    }

    // |Return the login name
    getPassword() {
        return this.loginDetails.password;
    }

    // |Set the password
    setPassword(password: string) {
        this.loginDetails.password = password;
    }

    // | Return the crypted athentication string
    getBase64Auth() {
        return btoa( this.getLoginName() + ':' + this.getPassword());
    }

    // |Return ALL the user properties
    getUserProperties() {
        return this.userProperties;
    }

    // |Set ALL the user properties
    setUserProperties(value: UserProperties) {
        this.userProperties = value;
    }

    // |Returns the user name
    getUserName() {
        return this.userProperties.user_name;
    }

    // |Set the user name
    setUserName(value: string) {
        this.userProperties.user_name = value;
    }

    // |Return the user code
    getUserCode() {
        return this.userProperties.user_code;
    }

    // |Set the user code
    setUserCode(value: string) {
        this.userProperties.user_code = value;
    }

    // |Set the user role
    setUserRole(value: string) {
        this.userProperties.role = value;
    }

    // |Return the user role
    getUserRole() {
        return this.userProperties.role;
    }

    // |Return the country code
    getUserCountryCode() {
        return this.userProperties.country;
    }

    // |Return the country name
    getUserCountryName() {
        return this.userProperties.country_name;
    }

    // |Set the country
    setUserCountry(code: string, desc: string) {
        this.userProperties.country = code;
        this.userProperties.country_name = desc;
    }

    // |Return the user company
    getUserCompany() { return this.userProperties.company; }

    // |Set the user company
    setUserCompany(company: Company) { this.userProperties.company = company; }

    setUserPurchaseOrganization(purchase_organization: PurchaseOrganization) {
        this.userProperties.purchase_organization = purchase_organization;
    }

    getUserPurchaseOrganization() { return this.userProperties.purchase_organization; }

    // |Return the supplier code
    getSupplierCode() {  return this.supplierProperties.supplier_code; }

    // |Set the supplier code
    setSupplierCode(value: string) {
        this.supplierProperties.supplier_code = value;
        // if the supplier name has been resetted,then you have to reset also the supplier code
        if (value === '' || value === null || value === undefined) {
            this.supplierProperties.supplier_name = value;
        }
    }

    // |Return the supplier name
    getSupplierName() { return this.supplierProperties.supplier_name; }

    // |Set the supplier name
    setSupplierName(value: string) { this.supplierProperties.supplier_name = value; }


    // |=====|=====|=====|=====|=====|=====|=====|=====| DIRECTIONAL USER DATA

    // |Return the directional code
    getDirectionalCode() { return this.directionalProperties.dierctional_code; }

    // |Set the directional code
    setDirectionalCode(value: string) { this.directionalProperties.dierctional_code = value; }

    // |Get the directional name
    getDirectionalName() { return this.directionalProperties.directional_name; }

    // |Set the directional name
    setDirectionalName(value: string) { this.directionalProperties.directional_name = value; }

    // |Get the directional email
    getDirectionalEmail() { return this.directionalProperties.directional_email; }

    // |Set the directional email
    setDirectionalEmail(value: string) { this.directionalProperties.directional_email = value; }

    // |=====|=====|=====|=====|=====|=====|=====|=====| AGENT DATA

    // |Return the agent code
    getAgentCode() { return this.agentProperties.agent_code; }

    // |Set the agent code
    setAgentCode(value: string) { this.agentProperties.agent_code = value; }

    // |Return the agent name
    getAgentName() { return this.agentProperties.agent_name; }

    // |Set the agent name
    setAgentName(value: string) { this.agentProperties.agent_name = value; }

    // |Return the agent email
    getAgentEmail() { return this.agentProperties.agent_email; }

    // |Set the agent emai
    setAgentEmail(value: string) { this.agentProperties.agent_email = value; }

    // |=====|=====|=====|=====|=====|=====|=====|=====| AREA MANAGER DATAS

    // |Return the area manager code
    getAreaManagerCode() { return this.areaManagerProperties.area_manager_code; }

    // |Set the area manager code
    setAreaManagerCode(value: string) { this.areaManagerProperties.area_manager_code = value; }

    // | Return the area manager name
    getAreaManagerName() { return this.areaManagerProperties.area_manager_name; }

    // | Set the area manager name
    setAreaManagerName(value: string) { this.areaManagerProperties.area_manager_name = value; }

    // | Return the welcome string
    getWelcome() {
        let dialogue = this.locale.getTerms().common.messages.WELCOME;
        dialogue += ' ' + this.getLoginName();
        return dialogue;
    }

    // |Assemble greetings with the informations retrieved from the data
    getWelcomeDetail() {
        let dialogue = '';
        let code = '';
        let name = '';

        if (this.getUserRole() === 'STDSUP') {
            code = this.labelFormatService.extractNumberLabel(this.getSupplierCode());
            name = this.getSupplierName();

            dialogue = name + '(' + code + ')';
        }

        /*
        if (this.getUserRole() === 'Z1') {
            dialogue = this.getAgentName();
            dialogue = dialogue + ', (' + this.labelFormatService.extractNumberLabel(this.getAgentCode()) + ') ';
            if (this.supplierService.getSupplierData().supplierCode !== undefined) {
                code = this.labelFormatService.extractNumberLabel(this.supplierService.getSupplierData().supplierCode);
                name = this.supplierService.getSupplierData().supplierName;
                dialogue = dialogue + ' - ' + name + ', (' + code + ')';
            }
        }

        if (this.getUserRole() === 'Z2') {

            code = this.labelFormatService.extractNumberLabel(this.getAreaManagerCode());
            name = this.getAreaManagerName();
            dialogue =  name + ', (' + code + ')';

            if (this.getAgentCode() !== '') {
                code = this.labelFormatService.extractNumberLabel(this.getAgentCode());
                name = this.getAgentName();
                dialogue = dialogue + ' - ' + name + ', (' + code + ')';

                if (this.supplierService..getSupplierData().supplierCode !== undefined) {
                    code = this.labelFormatService.extractNumberLabel(this.supplierService.getSupplierData().supplierCode);
                    name = this.supplierService..getSupplierData().supplierName;
                    dialogue = dialogue + ' - ' + name + ', (' + code + ')';
                }
            }
        }

        if (this.getUserRole() === 'UD') {
            if (this.getAreaManagerCode() !== '') {
                code = this.labelFormatService.extractNumberLabel(this.getAreaManagerCode());
                name = this.getAreaManagerName();
                dialogue =  name + ', (' + code + ')';

                if (this.getAgentCode() !== '') {
                    code = this.labelFormatService.extractNumberLabel(this.getAgentCode());
                    name = this.getAgentName();
                    dialogue = dialogue + ' - ' + name + ', (' + code + ')';

                    if (this.supplierService.getSupplierData().supplierCode !== undefined) {
                        code = this.labelFormatService.extractNumberLabel(this.supplierService.getSupplierData().supplierCode);
                        name = this.supplierService.getSupplierData().supplierName;
                        dialogue = dialogue + ' - ' + name + ', (' + code + ')';
                    }
                }
            }
        }
        */

        return dialogue;
    }

/*
    // |=====|=====|=====|=====|=====|=====|=====|=====| SALES AREA UTILITY
    // |Set the sales area number

    setUserSalesAreaNumber(value: Number) {
        this.selectedUserSalesArea = value;
    }
    // |Set ALL the sales area list
    setSalesAreaList(value) {
        if (value.length > 0) {
            this.userProperties.sales_areas_list = value;
        } else {
            this.userProperties.sales_areas_list = undefined;
        }
    }

    // |TRY to return the sales area likst
    getSalesAreaList() {
        try {
            return this.userProperties.sales_areas_list;
        } catch (error) {
            return undefined;
        }
    }

    // | Set all the data of the sales area
    initSalesAreaData(value) {
        console.log(value);
        // set the business organization
        const businessOrganization = new BusinessOrganization();
        businessOrganization.code = value.business_organization;
        businessOrganization.description = value.business_organization_description;
        this.setBusinesOrg(businessOrganization);
        // set distribution and comodity
        this.userProperties.distribution_channel = value.distribution_channel;
        this.userProperties.comodity_sector = value.division;
    }

    // |Returns the business organization
    getBusinessOrg() {
        try {
            return this.userProperties.business_organization;
        } catch (error) {
            console.log('[accountService] Get BusinessOrg failed: ' + error);
        }
    }

    // |Set the business organization
    setBusinesOrg(value: BusinessOrganization) {
        this.userProperties.business_organization = value;
    }

    hasBusinessOrg() {}

    // |Returns the sector
    getSector() {
        return this.userProperties.comodity_sector
    }

    // |Returns the distribution channel
    getChannel() {
        return this.userProperties.distribution_channel;
    }
    */

    // |=====|=====|=====|=====|=====|=====|=====|=====| USER PROPERTIES UTILITY
    // |Set the profile number
    setProfileNumber(value: Number) {
        this.selectedProfile = value;
    }

    // |Simply returns the profiles already collected
    getStoredProfiles() { return this.profiles; }

    // |Set all the profiles in the profiles array...a spartan (but working) method
    setProfiles(value) {
        let index = 0;
        let keep_going = true;
        let data ;
                this.profiles = [];
        do {
            data = value[index];
            if (data !== undefined) {
                this.profiles.push(data);
                index++;
            } else {
                keep_going = false;
            }
        }
        while (keep_going === true);
    }

    // |Load all the data of the profile
    initProfile(profile_number) { // , user_sales_areas_number) {
        // set the basic profile data
        console.log(this.profiles[profile_number]);
        this.setUserCode(this.profiles[profile_number].user_code);
        this.setUserName(this.profiles[profile_number].name1);
        this.setUserRole(this.profiles[profile_number].login_type);
        this.setUserCountry(this.profiles[profile_number].land1, this.profiles[profile_number].landx);

        const purchOrg = new PurchaseOrganization();
        purchOrg.code = this.profiles[profile_number].company_code;
        purchOrg.description = this.profiles[profile_number].company_code;
        this.setUserPurchaseOrganization(purchOrg);

        const company = new Company();
        company.code = this.profiles[profile_number].company_code;
        company.description = this.profiles[profile_number].company_description;
        this.setUserCompany(company);
        // this.setSalesAreaList(this.profiles[profile_number].user_sales_areas);

        // Set lang values
        this.locale.setLand1(this.profiles[profile_number].land1);
        this.locale.setLandx(this.profiles[profile_number].landx);

        if (this.getUserRole() === 'STDSUP') {
            this.setSupplierCode(this.getUserCode());
            this.setSupplierName(this.getUserName());
        } else if (this.getUserRole() === 'Z1' || this.getUserRole() === 'Z3') {
            this.setAgentCode(this.getUserCode());
            this.setAgentName(this.getUserName());
            if (this.getUserRole() === 'Z1') { this.status.setIsAgent(true); }
        } else if (this.getUserRole() === 'Z2') {
            this.setAreaManagerCode(this.getUserCode());
            this.setAreaManagerName(this.getUserName());
            this.status.setIsManager(true);
        } else if (this.getUserRole() === 'UD') {
            this.setDirectionalCode(this.getUserCode());
            this.setDirectionalName(this.getUserName    ());
            this.status.setIsDirectionalUser(true);
        }

        // init sales area
        // this.initSalesAreaData(this.profiles[profile_number].user_sales_areas[user_sales_areas_number]);

        // init user function
        this.buildUserFunctions(this.profiles[profile_number].user_functions);

        // Continue
        this.doContinueInit();
    }

    doContinueInit() {

        if (this.getUserRole() === 'STDSUP') {

            /*
            //Z_DL_LOADTAB
            this.loadParameters().subscribe(
                (response) => {

                    //Z_DL_INIT
                    this.loadSupplierData().subscribe(
                        (response) => {

                            this.doCompleteInit();
                        },
                        (error) => {
                            console.log('OPS ' + error);
                    });
                },
                (error) => {
                    console.log('OPS ' + error);
            });
            */
            // Z_DL_INIT
            this.loadSupplierData().subscribe(
                (response) => {
                    this.doCompleteInit();
                },
                (error) => {
                    console.log('OPS ' + error);
            });

        } else  {

            // Z_DL_LOADTAB
            this.loadParameters().subscribe(
                (response) => {
                    this.doCompleteInit();
                },
                (error) => {
                    console.log('OPS ' + error);
            });

        }
    }

    doCompleteInit() {
        // this.status.setLoadingAll(false);
        // this.status.setReadyToDisplay(true);
        this.status.setDataReadable(true);
        this.status.setUserLogged(true);
    }

    // |Get the profiles informations and if case of success set the login status true
    getProfiles() {
        console.log(this.locale);

        if (this.locale !== undefined) {
            this.ui_context = this.locale.getTerms().ui_context;
        }
        /* const test = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));
        console.log('TEST: ' + test); */
        this.http.get(this.serverMapping.profileURL +
                      '?language=' + this.locale.getPreferredLanguage() +
                      '&ui_context=' + this.ui_context +
                      '&username=' + this.getLoginName()
                ).subscribe((response) => {
                    const data = response.json();
                    // TODO : GROWL MANAGER
                    if (this.growlManager.checkForErrorInResponse(data)) {
                        this.growlManager.showMessagesByResponse(data);
                        setTimeout(() => this.doLogout(), 200);
                    }else {
                        this.setLogged(true);

                        this.setProfiles(data.contained_bean.profiles);

                        if (this.profiles.length > 1) {
                            this.loginComponent.setProfileSelection(true);
                        } else {
                            this.initProfile(0); // ,0);
                            /*
                            if (this.profiles[0].user_sales_areas.length > 1) {
                                this.loginComponent.setProfileSelection(true);
                            } else {
                                this.initProfile(0,0);
                            }
                            */
                        }
                    }
                });
    }

    doLogout() {
        console.log('Logout');
        this.http.get(this.serverMapping.logoutURL).subscribe(
            (response) => {
                this.clear();
                this.status.setUserLogged(false);
                //window.location.reload();
            },
            (error) => {
                console.log(error);
            }
        );
    }

    // |Does all the login stuff and redirects to profile load method in case of success
    doLogin(plsWait) {
        const auth64 = this.getBase64Auth();
        var headers = new HttpHeaders( {'Authorization': 'Basic ' + auth64, 'Accept-Language': + '' + this.locale.getPreferredLanguage()} );
        this.httpClient.get(this.serverMapping.loginURL , { headers: headers }).subscribe(
            (data) => {
                this.getProfiles();
            },
            (error) => {
                this.status.setLoginError(true);
                setTimeout(() => plsWait.hide(), 200);
            }
        );
    }

    loadParameters() {
        return this.customizingService.loadTable(this.getUserPurchaseOrganization().code);
    }

    loadSupplierData() {
        return this.supplierService.loadSupplierData(
                                            this.getUserPurchaseOrganization().code,
                                            this.getUserCompany().code,
                                            this.getSupplierCode(),
                                            this.locale.getPreferredLanguage());
    }

    doTokenLogin(token) {
      
      const requestOptions = {}

      this.http.get(this.serverMapping.tokenlLoginURL, requestOptions).subscribe((response) => {
        const data = response.json();
        if(data && data.result){
            this.setLoginName(data.auth_user.username);
            this.setPassword("");
            // this.getProfiles();
            setTimeout(() => this.getProfiles(), 1000);
          
        }else{
          const error401 = this.locale.getMiscTerms().ERROR_401;
          this.growlManager.showError(error401);
          this.status.setLoginError(true);
        }
      },
      (error) => {
        // console.log(error);
        this.status.setLoginError(true);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/accountService.service.ts